import SettingsSidebar from './container'
export { SettingsSidebar }
export default SettingsSidebar